<!-- <template>
  <div id="stock-trade-table">
    <div class="tw-relative tw-w-full tw-bg-white tw-rounded-lg tw-p-4">
      <div class="tw-w-full tw-overflow-auto">
        <table class="table tw-w-full">
          <thead v-if="tableRows.length !== 0" class="header">
            <tr class="header-row">
              <th
                class="header-data tw-font-normal tw-py-6"
                ref="tableHead"
                :style="gridStyling"
              >
                <div
                  class="tw-justify-self-start tw-text-sm tw-text-black-light"
                  v-for="(header, index) in tableHeaders"
                  :key="'header' + index"
                >
                  {{ header }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr class="body-row">
              <td class="body-data tw-min-h-full" ref="tableRow">
                <div
                  class="data tw-border-t tw-border-gray_dark tw-py-6"
                  v-for="(details, index) in tableRows"
                  :key="'row' + index"
                  :style="gridStyling"
                >
                  <div
                    class="tw-self-center"
                    v-for="(detail, index) in details"
                    :key="'column' + index"
                  >
                    <p
                      v-html="detail"
                      class="tw-text-sm"
                      :class="[
                        availableStatuses.includes(detail)
                          ? `${detail.toLowerCase()}`
                          : null,
                      ]"
                    ></p>
                  </div>
                  <button
                    v-if="details.others.includes('Buy')"
                    class="buy tw-font-semibold"
                    @click="showModal(details, index)"
                  >
                    <span>BUY</span>
                  </button>
                  <button
                    v-if="details.others.includes('Sold')"
                    class="sold tw-font-semibold"
                  >
                    <span>SOLD</span>
                  </button>
                  <button
                    v-if="details.others.includes('Sell')"
                    class="sell tw-font-semibold"
                    @click="showModal(details, index)"
                  >
                    <span>SELL</span>
                  </button>
                </div>
                <EmptyState v-if="tableRows.length === 0 && !smallLoading">
                  <template v-slot:message>
                    <p class="message tw-text-center tw-text-gray tw-my-3">
                      This order book is empty
                    </p>
                  </template>
                </EmptyState>
                <SmallLoader v-if="smallLoading" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <SideModal
      v-if="showSideModal"
      title="Buy Confirmation"
      @close="showSideModal = !showSideModal"
    >
      <template v-slot:content>
        <div class="tw-px-6 tw-mt-8">
          <div
            class="tw-bg-gray-light tw-rounded-t-lg tw-border-b tw-px-6 tw-py-6 tw-mt-6"
          >
            <p class="tw-text-black-light">You're buying</p>
            <h3 class="tw-text-lg tw-font-semibold">
              {{ esopOrder[index]?.amount }} ESOP token
            </h3>
          </div>
          <div
            class="tw-flex tw-justify-between tw-bg-gray-light tw-border-b tw-px-6 tw-py-6"
          >
            <div>
              <p class="tw-text-black-light">For</p>
              <h3 class="tw-text-lg tw-font-semibold">
                {{ formatAmountToDollar(esopOrder[index]?.price, 2, "USD") }}
              </h3>
            </div>
            <div>
              <p class="tw-text-black-light">Transaction fee</p>
              <h3 class="tw-text-lg tw-font-semibold">1%</h3>
            </div>
          </div>
          <div class="tw-bg-gray-light tw-rounded-b-lg tw-px-6 tw-py-6">
            <p class="tw-text-black-light">Seller</p>
            <div>
              <h3 class="tw-text-lg tw-font-semibold">
                {{ esopOrder[index].user?.fname }}
                {{ esopOrder[index].user?.lname }}
              </h3>
            </div>
          </div>
          <PinConfirmation
            class="tw-mt-6"
            btnTitle="Buy"
            @confirmed="buyEsopToken"
          />
        </div>
      </template>
    </SideModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EmptyState from "@/components/notification/EmptyState.vue";
import SideModal from "@/components/general/sidemodal/SideModal";
import PinConfirmation from "@/components/general/PinConfirmation.vue";
import {
  formatISODate,
  formatAmountToDollar,
  truncate,
} from "@/utils/helpers.js";

export default {
  name: "StockTradeTable",

  components: {
    EmptyState,
    SideModal,
    PinConfirmation,
  },

  data() {
    return {
      smallLoading: false,
      showSideModal: false,
      index: "",
      confirmDetails: {},
      tableRows: [],
      tableHeaders: [
        "",
        "Employee name",
        "Email address",
        "Date of trade",
        "Amount traded",
        "Price",
        "Action",
      ],
      availableStatuses: [
        "Pending",
        "Completed",
        "Failed",
        "Terminated",
        "Sell",
        "Sold",
        "Buy",
      ],
    };
  },

  computed: {
    ...mapGetters("Esop", ["esopOrder", "esopToken"]),

    gridStyling() {
      return {
        "grid-template-columns": `${20}px repeat(${6}, ${150}px)`,
      };
    },
  },

  created() {
    this.getDetails();
  },

  methods: {
    ...mapActions("Esop", ["getEsopOrder", "getEsopToken", "buyEsop"]),

    formatAmountToDollar,

    showModal(details, index) {
      this.index = index;
      this.confirmDetails = details;
      this.showSideModal = !this.showSideModal;
    },

    buyEsopToken() {
      let id = this.esopOrder[this.index].token._id;
      let payload = {
        id,
        amount: this.esopOrder[this.index]?.amount,
        price: this.esopOrder[this.index]?.price,
      };
      this.buyEsop(payload);
    },

    async getDetails() {
      this.smallLoading = !this.smallLoading;
      await this.getEsopToken();
      await this.getEsopOrder(this.esopToken._id);
      this.smallLoading = !this.smallLoading;
    },

    updateTableRow(orders) {
      this.tableRows = orders.map((order) => {
        let type = "";
        switch (order.type) {
          case "BUY":
            type = "Sell";
            break;
          case "Sell":
            type = "Buy";
            break;

          default:
            break;
        }
        if (order.amount === 0) type = "Sold";
        return {
          others: `<span class="tw-hidden">${type} ${order.token._id} ${order.user.fname} ${order.user.lname}</span>`,
          name: `${order.user.fname} ${order.user.lname}`,
          email: truncate(order.user.email, 20),
          date: `${formatISODate(order.createdAt)}`,
          amount: order.amount,
          price: formatAmountToDollar(order.price, 2, "USD"),
        };
      });
    },
  },

  watch: {
    esopOrder(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateTableRow(this.esopOrder);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#stock-trade-table {
  @include fadeIn;

  .table {
    .header {
      .header-row {
        .header-data {
          display: grid;
          column-gap: 2rem;
        }
      }
    }
    .table-body {
      .body-row {
        .body-data {
          .data {
            display: grid;
            column-gap: 2rem;
            font-size: 0.7rem;

            // Added with javascript
            .sell,
            .sold,
            .buy {
              text-align: center;
              padding: 0.5rem;
              border-radius: 5px;
              cursor: pointer;
            }
            .buy {
              color: $success;
              background-color: $success-light;
              max-width: 5.4rem;
            }
            .sold {
              color: $brand-primary;
              background-color: $brand-primary-light;
              max-width: 5.4rem;
            }
            .sell {
              color: $error;
              background-color: $error-light;
              max-width: 4rem;
            }
          }
        }
      }
    }
  }
}
</style> -->

<template>
  <div id="stock-trade-table">
    <div class="tw-relative tw-w-full tw-bg-white tw-rounded-lg tw-p-4">
      <div class="tw-w-full tw-overflow-auto">
        <table class="table tw-w-full">
          <thead v-if="tableRows.length !== 0" class="header">
            <tr class="header-row">
              <th
                class="header-data tw-font-normal tw-py-6"
                ref="tableHead"
                :style="gridStyling"
              >
                <div
                  class="tw-justify-self-start tw-text-sm tw-text-black-light"
                  v-for="(header, index) in tableHeaders"
                  :key="'header' + index"
                >
                  {{ header }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr class="body-row">
              <td class="body-data tw-min-h-full" ref="tableRow">
                <div
                  class="data tw-border-t tw-border-gray_dark tw-py-6"
                  v-for="(details, index) in tableRows"
                  :key="'row' + index"
                  :style="gridStyling"
                >
                  <div
                    class="tw-self-center"
                    v-for="(detail, index) in details"
                    :key="'column' + index"
                  >
                    <p
                      v-html="detail"
                      class="tw-text-sm"
                      :class="[
                        availableStatuses.includes(detail)
                          ? `${detail.toLowerCase()}`
                          : null,
                      ]"
                    ></p>
                  </div>
                  <!-- <button
                    v-if="details.others.includes('Buy')"
                    class="buy tw-font-semibold"
                    @click="showModal(details, index)"
                  >
                    <span>BUY</span>
                  </button>
                  <button
                    v-if="details.others.includes('Sold')"
                    class="sold tw-font-semibold"
                  >
                    <span>SOLD</span>
                  </button>
                  <button
                    v-if="details.others.includes('Sell')"
                    class="sell tw-font-semibold"
                    @click="showModal(details, index)"
                  >
                    <span>SELL</span>
                  </button> -->
                </div>
                <EmptyState v-if="tableRows.length === 0 && !smallLoading">
                  <template v-slot:message>
                    <p class="message tw-text-center tw-text-gray tw-my-3">
                      This order book is empty
                    </p>
                  </template>
                </EmptyState>
                <SmallLoader v-if="smallLoading" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <SideModal
      v-if="showSideModal"
      title="Buy Confirmation"
      @close="showSideModal = !showSideModal"
    >
      <template v-slot:content>
        <div class="tw-px-6 tw-mt-8">
          <div
            class="tw-bg-gray-light tw-rounded-t-lg tw-border-b tw-px-6 tw-py-6 tw-mt-6"
          >
            <p class="tw-text-black-light">You're buying</p>
            <h3 class="tw-text-lg tw-font-semibold">
              {{ esopOrder[index]?.amount }} ESOP token
            </h3>
          </div>
          <div
            class="tw-flex tw-justify-between tw-bg-gray-light tw-border-b tw-px-6 tw-py-6"
          >
            <div>
              <p class="tw-text-black-light">For</p>
              <h3 class="tw-text-lg tw-font-semibold">
                {{ formatAmountToDollar(esopOrder[index]?.price, 2, "USD") }}
              </h3>
            </div>
            <div>
              <p class="tw-text-black-light">Transaction fee</p>
              <h3 class="tw-text-lg tw-font-semibold">1%</h3>
            </div>
          </div>
          <div class="tw-bg-gray-light tw-rounded-b-lg tw-px-6 tw-py-6">
            <p class="tw-text-black-light">Seller</p>
            <div>
              <h3 class="tw-text-lg tw-font-semibold">
                {{ esopOrder[index].user?.fname }}
                {{ esopOrder[index].user?.lname }}
              </h3>
            </div>
          </div>
          <PinConfirmation
            class="tw-mt-6"
            btnTitle="Buy"
            @confirmed="buyEsopToken"
          />
        </div>
      </template>
    </SideModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EmptyState from "@/components/notification/EmptyState.vue";
import SideModal from "@/components/general/sidemodal/SideModal";
import PinConfirmation from "@/components/general/PinConfirmation.vue";
import {
  formatISODate,
  formatAmountToDollar,
  truncate,
} from "@/utils/helpers.js";

export default {
  name: "StockTradeTable",

  components: {
    EmptyState,
    SideModal,
    PinConfirmation,
  },

  data() {
    return {
      smallLoading: false,
      showSideModal: false,
      index: "",
      confirmDetails: {},
      tableRows: [],
      tableHeaders: [
        "",
        "Employee name",
        "Email address",
        "Date of trade",
        "Amount",
        "Price",
        "Status",
        "Type",
      ],
      availableStatuses: [
        "Pending",
        "Completed",
        "Failed",
        "Terminated",
        "Sell",
        "Sold",
        "Buy",
      ],
    };
  },

  computed: {
    ...mapGetters("Esop", ["esopOrder", "esopToken"]),

    gridStyling() {
      return {
        "grid-template-columns": `${0}px ${150}px ${150}px repeat(${5}, ${100}px)`,
      };
    },
  },

  created() {
    this.getDetails();
  },

  methods: {
    ...mapActions("Esop", ["getEsopOrder", "getEsopToken", "buyEsop"]),

    formatAmountToDollar,

    showModal(details, index) {
      this.index = index;
      this.confirmDetails = details;
      this.showSideModal = !this.showSideModal;
    },

    buyEsopToken() {
      let id = this.esopOrder[this.index].token._id;
      let payload = {
        id,
        amount: this.esopOrder[this.index]?.amount,
        price: this.esopOrder[this.index]?.price,
      };
      this.buyEsop(payload);
    },

    async getDetails() {
      this.smallLoading = !this.smallLoading;
      await this.getEsopToken();
      await this.getEsopOrder(this.esopToken._id);
      this.smallLoading = !this.smallLoading;
    },

    updateTableRow(orders) {
      this.tableRows = orders.map((order) => {
        // let type = "";
        // switch (order.type) {
        //   case "BUY":
        //     type = "Sell";
        //     break;
        //   case "Sell":
        //     type = "Buy";
        //     break;

        //   default:
        //     break;
        // }
        // if (order.amount === 0) type = "Sold";
        let name = order.user.name
          ? order.user.name
          : order.user.fname + " " + order.user.lname;
        return {
          others: `<span class="tw-hidden">${order.type} ${order.token._id} ${order.user.fname} ${order.user.lname}</span>`,
          name,
          email: truncate(order.user.email, 20),
          date: `${formatISODate(order.createdAt)}`,
          amount: order.amount,
          price: formatAmountToDollar(order.price, 2, "USD"),
          status: order.status === "Active" ? "Pending" : "",
          type: order.type,
        };
      });
    },
  },

  watch: {
    esopOrder(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateTableRow(this.esopOrder);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#stock-trade-table {
  @include fadeIn;

  .table {
    .header {
      .header-row {
        .header-data {
          display: grid;
          column-gap: 2rem;
        }
      }
    }
    .table-body {
      .body-row {
        .body-data {
          .data {
            display: grid;
            column-gap: 2rem;
            font-size: 0.7rem;

            // Added with javascript
            .sell,
            .sold,
            .pending,
            .buy {
              text-align: center;
              padding: 0.5rem;
              border-radius: 5px;
            }
            .buy {
              color: $success;
              background-color: $success-light;
              max-width: 4rem;
            }
            .sold {
              color: $brand-primary;
              background-color: $brand-primary-light;
              max-width: 5.4rem;
            }
            .pending {
              color: $warning;
              background-color: $warning-light;
              max-width: 5.4rem;
            }
            .sell {
              color: $error;
              background-color: $error-light;
              max-width: 4rem;
            }
          }
        }
      }
    }
  }
}
</style>
